import React, { useEffect, useState } from 'react';
import { DefaultRootState, useDispatch, useSelector } from 'react-redux';
import { Spinner } from '../../components/UI';
import useCMStyles from './useCMStyles';
import {
    Button,
    Paper,
    Box,
    Typography,
    makeStyles,
    IconButton,
    Tooltip,
    TablePagination,
    Grid,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableBody,
    Divider,
} from '@material-ui/core';
import { CM_FILTER_CARDS, CM_FILTERS } from './helper.cm';
import useCM from './useCM';
import Searchbar from '../../components/Searchbar';
import FilterModal, {
    FilteredState,
} from '../../components/Modals/FilterModal';
import { te } from 'date-fns/locale';
import { CM_TABLE_COLUMNS } from './helper.cm';
import { CMTableCell, CMTableHeadCell } from './utility.component.cm';
import AddTeamLead from '../../components/Modals/AddTeamLead';
interface ClusterManagementPageProps {
    [key: string]: any;
}
const ClusterManagementPage: React.FC = ({
    heliosTrackingData = [],
    staffTrackAndTrace,
    ...props
}: ClusterManagementPageProps) => {
    //store values

    const {
        isLoading,
        styles,
        activeFilterCard,
        prepareFilterCard,
        prepareFilterOptions,
        containerRef,
        searchTextValue,
        onFilterApplied,
        filterValues,
        pagination,
        handleChangePage,
        handleChangeRowsPerPage,
        teamLeads,
        onBackendSearch,
        onSearchTextChange,
        onRemoveAll,
        getColumnComponentValue,
        cm,
        handleActiveFilterCard,
        handleRowClick,
        addTeamLeadModalOpen,
        handleCloseAddTeamLeadModal,
        handleOpenAddTeamLeadModal,
    } = useCM(props);
    console.log('cm ddd', cm);
    return (
        <Spinner loading={isLoading}>
            <Paper
                style={{ padding: '1rem' }}
                className={styles.filterContainer}
                elevation={0}
            >
                <Grid container spacing={2}>
                    {CM_FILTER_CARDS.map((card: any, index: number) => {
                        return (
                            <Grid
                                key={index}
                                xs={card?.xs ? card?.xs : true}
                                item
                                style={
                                    {
                                        //maxWidth: 'fit-content',
                                    }
                                }
                            >
                                <Paper
                                    className={styles.filterBox}
                                    style={
                                        card?.filterValue?.type ===
                                            activeFilterCard?.type &&
                                        !activeFilterCard?.subType
                                            ? {
                                                  backgroundColor: '#D1D8FF',
                                              }
                                            : {}
                                    }
                                    onClick={() => {
                                        handleActiveFilterCard(
                                            card?.filterValue,
                                        );
                                    }}
                                >
                                    {prepareFilterCard(card)}
                                </Paper>
                            </Grid>
                        );
                    })}
                </Grid>
            </Paper>
            <Paper style={{ padding: '1rem', paddingBottom: 0 }} elevation={0}>
                <Box
                    display={'flex'}
                    flexDirection={'row'}
                    alignItems={'center'}
                    justifyContent={'space-between'}
                    mb={2}
                >
                    <Box
                        display={'flex'}
                        flexDirection={'row'}
                        alignItems={'center'}
                        flex={1}
                    >
                        <Searchbar
                            placeHolderText="Search by TL’s details"
                            style={{
                                width: 'calc(100vw - 77%)',
                            }}
                            dataSource={null}
                            backendSearchbar={true}
                            onBackendSearch={onBackendSearch}
                            value={searchTextValue}
                            keys={['name', 'hubName']}
                            onFilter={async (filteredData: any) => {}}
                            onChange={onSearchTextChange}
                        />

                        {/* <FilterModal
                            disabled={false}
                            filterOptions={prepareFilterOptions()}
                            filteredValues={filterValues}
                            onFilterApplied={onFilterApplied}
                            onClose={null}
                            onRemoveAll={onRemoveAll}
                        />
                        <FilteredState
                            filterOptions={prepareFilterOptions()}
                            filteredValues={filterValues}
                            onDelete={(filterKey: any) => {}}
                            count={null}
                            selectInfo={null}
                            selected={null}
                            maxShow={4}
                        /> */}
                    </Box>
                    <Box
                        display={'flex'}
                        flexDirection={'row'}
                        alignItems={'flex-end'}
                    >
                        <Button
                            variant="contained"
                            color="primary"
                            className="btn-pos-end"
                            onClick={() => {
                                handleOpenAddTeamLeadModal();
                            }}
                            //disabled={!permissions.create}
                            disableElevation
                        >
                            Add TL
                        </Button>
                    </Box>
                </Box>
                <Paper
                    ref={containerRef}
                    className={styles.container}
                    elevation={0}
                >
                    {cm?.teamLeads?.teamLeadStatsList?.length ? (
                        <>
                            <TableContainer
                                component={Box}
                                className={styles.tableContainer}
                            >
                                <Table
                                    stickyHeader
                                    aria-label="Team Leads table"
                                >
                                    <TableHead>
                                        <TableRow>
                                            {CM_TABLE_COLUMNS?.map(
                                                (column: any, index: any) => {
                                                    return (
                                                        <CMTableHeadCell
                                                            key={`column${index}`}
                                                        >
                                                            {column?.name}
                                                        </CMTableHeadCell>
                                                    );
                                                },
                                            )}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {cm?.teamLeads?.teamLeadStatsList?.map(
                                            (row: any, rowIndex: number) => (
                                                <>
                                                    <TableRow
                                                        style={{
                                                            cursor: 'pointer',
                                                        }}
                                                        key={row.name}
                                                        onClick={(e: any) => {
                                                            handleRowClick(
                                                                e,
                                                                row,
                                                                rowIndex,
                                                            );
                                                        }}
                                                    >
                                                        {CM_TABLE_COLUMNS?.map(
                                                            (
                                                                column: any,
                                                                index: any,
                                                            ) => {
                                                                return (
                                                                    <CMTableCell
                                                                        key={`row${index}`}
                                                                    >
                                                                        {getColumnComponentValue(
                                                                            row,
                                                                            column,
                                                                            null,
                                                                        )}
                                                                    </CMTableCell>
                                                                );
                                                            },
                                                        )}
                                                    </TableRow>
                                                    <Divider
                                                        style={{
                                                            margin: '4px 0',
                                                            backgroundColor:
                                                                '#fff',
                                                        }}
                                                    />
                                                </>
                                            ),
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </>
                    ) : (
                        <Box
                            display={'flex'}
                            flexDirection={'column'}
                            alignItems={'center'}
                            justifyContent={'center'}
                        >
                            <Typography
                                component={'p'}
                                style={{
                                    color: '#ED0000',
                                    fontWeight: 700,
                                }}
                            >
                                No data found. Please retry filters and try
                                again.
                            </Typography>
                            <Typography
                                component={'p'}
                                style={{
                                    color: '#4CAF50',
                                    fontWeight: 700,
                                }}
                            >
                                Add Team Lead
                            </Typography>
                        </Box>
                    )}
                    {!!cm?.teamLeads?.teamLeadStatsList?.length && (
                        <Box className={styles.paginationContainer}>
                            <TablePagination
                                rowsPerPageOptions={
                                    cm?.totalFilteredCount > 25 ||
                                    cm?.totalCount > 25
                                        ? [25, 50, 75, 100]
                                        : []
                                }
                                component="div"
                                count={cm?.teamLeads?.totalFilteredCount}
                                rowsPerPage={pagination?.pageSize}
                                page={pagination?.pageNo}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                            />
                        </Box>
                    )}
                </Paper>
            </Paper>
            {addTeamLeadModalOpen && (
                <AddTeamLead
                    open={addTeamLeadModalOpen}
                    isEdit={false}
                    data={undefined}
                    onClose={() => {
                        handleCloseAddTeamLeadModal();
                    }}
                />
            )}
        </Spinner>
    );
};
export default ClusterManagementPage;
